/* eslint-disable react/prop-types */
/* eslint-disable prettier/prettier */
import styled from '@emotion/styled';
import _ from 'lodash';
import { useState } from 'react';

import Theme from '../../themes';
import IconInfoAlt from '../ComponentLibrary/icons/icon-info-alt';

const IconContainer = styled.div`
  bottom: 10px;
  cursor: pointer;
  display: inline-block;
  filter: drop-shadow(0 4px 4px rgba(0, 0, 0, 0.25));
  position: absolute;
  z-index: 1;

  ${props => props.alignment === 'left' && `
    left: 10px;
  `}

  ${props => props.alignment === 'right' && `
    right: 10px;
  `}

  @media screen and (min-width: 768px) {
    bottom: 25px;

    ${props => props.alignment === 'left' && `
      left: 25px;
    `}

    ${props => props.alignment === 'right' && `
      right: 25px;
    `}
  }

  @media screen and (min-width: 1200px) {
    &:hover {
      .attribution {
        display: inline-block;
      }
    }
  }

  svg {
    display: inline-block;
    height: 25px;
    position: relative;
    width: 25px;
  }
`;

const Attribution = styled.div`
  background-color: #000000;
  border: 1px solid #FFFFFF;
  border-radius: 4px;
  bottom: 32px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  color: #FFFFFF;
  display: ${props => (props.attributionVisible ? 'inline-block' : 'none')};
  font-size: 12px;
  line-height: 14px;
  min-width: 174px;
  padding: 4px;
  position: absolute;

  ${props => props.alignment === 'left' && `
    left: 0;
  `}

  ${props => props.alignment === 'right' && `
    right: 0;
  `}
`;

const ImageAttribution = ({ alignment = 'right', className, copy }) => {
  const [attributionVisible, setAttributionVisible] = useState(false);

  const showAttribution = (event) => {
    event.stopPropagation();
    setAttributionVisible(!attributionVisible);
  };

  if (_.isEmpty(copy)) return null;

  return (
    <IconContainer className={className} alignment={alignment} onClick={(event) => showAttribution(event)}>
      <IconInfoAlt />
      <Attribution className="attribution" alignment={alignment} attributionVisible={attributionVisible}>
        {copy}
      </Attribution>
    </IconContainer>
  );
};

export default ImageAttribution;
